import { useForm } from 'react-hook-form';
import { RequestStatus } from "../../../request";
import { RetentionReport } from "./reducer";

export const FetchRetentionReport = ({
  from,
  until,
  breakdowns,
  periodicity,
  filters,
  by = "event",
  userFrom,
  userUntil,
  coinsFilters,
}: {
  from: Date;
  until: Date;
  breakdowns?: string[];
  periodicity?: "daily" | "weekly" | "monthly" | "yearly";
  filters?: any;
  by?: "event" | "usage";
  userFrom?: string;
  userUntil?: string;
  coinsFilters?: {
    changeType:
      | "usage"
      | "challenge_open"
      | "challenge_app_event"
      | "challenge_app_revenue_event";
  };
}) => {
  return {
    type: "retention-request-report",
    from: from,
    until: until,
    filters,
    breakdowns: breakdowns,
    periodicity,
    by,
    userFrom,
    userUntil,
    coinsFilters,
  };
};

export const UpdateRetentionReportRequestState = (
  requestState: RequestStatus
) => {
  return {
    type: "retention-update-request-state",
    requestState: requestState,
  };
};

export const UpdateRetentionReport = (report: RetentionReport) => {
  return {
    type: "retention-update-report",
    report: report,
  };
};

export const ResetRetentionData = () => {
  return {
    type: "retention-reset-data",
  };
};
